<template>
  <div class="searchInfo">
    <div class="searchIfo_item_block">
      <div class="searchIfo_info_row">
        <div class="searchIfo_info_row_key">
          <el-icon><LocationInformation /></el-icon>省份、城市
        </div>
      </div>
      <div class="searchIfo_info_row">
        <div class="searchIfo_info_row_value">
          <el-select
            v-model="data.province"
            placeholder="请选择省份"
            @change="changeProvince()"
          >
            <el-option
              v-for="(item, index) in provinces"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="searchIfo_info_row">
        <div class="searchIfo_info_row_value">
          <el-select v-model="data.city" placeholder="请选择城市">
            <el-option
              v-for="(item, index) in citys"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="searchIfo_item_block">
      <div class="searchIfo_info_row">
        <div class="searchIfo_info_row_key">
          <el-icon><CreditCard /></el-icon>疾病类型
        </div>
      </div>
      <div class="searchIfo_info_row">
        <div class="searchIfo_info_row_value">
          <el-select
            v-model="data.diseases_top_type"
            placeholder="请选择癌种"
            @change="changeDisease"
          >
            <el-option
              v-for="(item, index) in $config.types.disease"
              :key="index"
              :label="index"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="searchIfo_info_row">
        <div class="searchIfo_info_row_value">
          <el-select v-model="data.diseases" placeholder="请选择疾病类型">
            <el-option
              v-for="(item, index) in $config.types.disease[
                search.diseases_top_type
              ] || []"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="searchInfo_btnGroup">
      <el-button class="reply_btn" size="small" type="success" @click="doReset">
        <span>重置</span>
      </el-button>
      <el-button
        class="reply_btn"
        size="small"
        type="primary"
        @click="doSearch"
      >
        <span>确认筛选</span>
      </el-button>
    </div>
  </div>
</template>
<script>
import { LocationInformation, CreditCard } from "@element-plus/icons";
export default {
  name: "searchInfo",
  props: {
    search: {
      type: Object,
      default: [],
    },
  },
  components: {
    LocationInformation,
    CreditCard,
  },
  data() {
    return {
      data: {},
      config: { citys: [] },
    };
  },
  computed: {
    provinces() {
      return this.config.citys.map((item) => item.name);
    },
    citys() {
      if (!this.search.province) return [];
      let index = this.provinces.indexOf(this.search.province);
      if (index == -1) return [];

      return this.config.citys[index].sub.map((item) => item.name);
    },
  },
  async created() {
    this.data = this.search;
    this.config.citys = await this.$tools.getCityConfig();
  },
  methods: {
    changeProvince() {
      this.data.city = "";
    },
    changeDisease() {
      this.data.diseases = "";
    },
    doReset() {
      let data = {
        province: "",
        city: "",
        diseases_top_type: "",
        diseases: "",
      };
      this.$emit("doReset", data);
    },
    doSearch() {
      this.$emit("doSearch", this.data);
      this.doReset();
    },
  },
};
</script>
<style >
.searchInfo {
  width: 20rem;
  background: #ffffff;
  box-shadow: 0 0 0.2rem 0.2rem #cccaca;
  border-radius: 0.1rem;
  font-size: 0.8rem !important;
}
.searchIfo_item_block {
  /* -bs-bg-opacity: 1; */
  /* padding: 0.5rem; */
}
.searchIfo_info_row {
  min-height: 2.5rem;
  display: flex;
  align-items: center;
}
.searchIfo_info_row_key {
  padding: 0 1rem;
  display: flex;
  align-items: center;
}
.searchIfo_info_row_key .el-icon {
  padding-right: 0.5rem;
}
.searchIfo_info_row_key .el-icon svg {
  font-size: 0.8rem;
}
.searchIfo_info_row_value {
  flex: 1 0 0;
  background: #f7f7f7;
  padding: 0 1rem;
}
.searchInfo .el-select {
  width: 100%;
  border: none;
  background: #f7f7f7;
}
.searchInfo .el-input__inner {
  border: none !important;
  background: #f7f7f7;
}
.el-input__inner::placeholder {
  font-size: 0.8rem !important;
}
.searchInfo_btnGroup {
  width: 100%;
  border: none !important;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}
</style>